import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { appconfig } from '../config';
import uuid from 'uuid';
import Header from './Header';
import Menu from './Menu';
import Orders from './Orders';
import TicketTotal from './TicketTotal';
import TicketTags from './TicketTags';
import Commands from './Commands';
import MyTickets from './MyTickets';
import Signalr from '../signalr';
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import * as Queries from '../queries';
import * as Actions from '../actions';
import Logger from '../helpers/logger';

import QuantityPad from './QuantityPad';
import { addOrderToOkc } from '../services/okcService';

import { getOnlyTsmEnabled } from '../services/okcSettingsService';



class App extends Component {

    constructor(props) {
        super(props);
        this.isAddingOrderLocked = false;

        this.state = {
            quantityInput: '',
            isQuantityPadOpen: false,
            showInposTsmButton: localStorage['show_inpos_tsm_button'] === 'true',
            currentUser: undefined,
            isAdmin: localStorage['current_user_is_admin'] === 'true',
            isUserLoaded: localStorage['current_user_is_admin'] !== undefined,
            isBusy: false,
            busyMessage: '',
            isAddingOrder: false
        };
    }

    startBusy = (message = 'İşlem yapılıyor...') => {
        if (this.busyTimer) {
            clearTimeout(this.busyTimer);
        }

        this.setState({
            isBusy: true,
            busyMessage: message
        });

        this.busyTimer = setTimeout(() => {
            this.setState({
                isBusy: false,
                busyMessage: ''
            });
        }, 15000);
    }

    stopBusy = () => {
        if (this.busyTimer) {
            clearTimeout(this.busyTimer);
            this.busyTimer = null;
        }

        this.setState({
            isBusy: false,
            busyMessage: ''
        });
    }

    hydrateCachedPermissions = () => {
        this.setState({
            isAdmin: localStorage['current_user_is_admin'] === 'true',
            isUserLoaded: localStorage['current_user_is_admin'] !== undefined,
            showInposTsmButton: localStorage['show_inpos_tsm_button'] === 'true'
        });
    }

    componentDidMount() {
        if (this.redirectToLoginIfNeeded()) {
            return;
        }

        this.hydrateCachedPermissions();

        this.loadCurrentUser();
        this.loadInposTsmVisibility();

        if (localStorage['terminalId']) {
            var terminalId = localStorage['terminalId'];
            Queries.getTerminalExists(terminalId, (result) => {
                if (result) {
                    Queries.getTerminalTicket(terminalId, (ticket) => {
                        this.props.changeTerminalId(terminalId);
                        this.props.setTicket(ticket);
                    });
                } else {
                    Queries.registerTerminal((newTerminalId) => this.updateTerminalId(newTerminalId));
                }
            });
        }
        else {
            Queries.registerTerminal((terminalId) => this.updateTerminalId(terminalId));
        }

        Signalr.connect((message) => {
            if (message.indexOf('TICKET_REFRESH') > -1) {
                Logger.log('Ticket refreshed');
                this.props.ticketsNeedsRefresh();
            }
        });
    }

    componentDidUpdate() {
        this.redirectToLoginIfNeeded();
    }

    toggleQuantityPad = () => {
        this.setState(prev => ({
            isQuantityPadOpen: !prev.isQuantityPadOpen
        }));
    }

    closeQuantityPad = () => {
        this.setState({ isQuantityPadOpen: false });
    }

    appendQuantityValue = (value) => {
        let current = this.state.quantityInput || '';

        if (value === '.') {
            if (current.indexOf('.') > -1) return;

            if (current === '') {
                this.setState({ quantityInput: '0.' });
                return;
            }

            this.setState({ quantityInput: current + '.' });
            return;
        }

        this.setState({ quantityInput: current + value });
    }

    backspaceQuantity = () => {
        let current = this.state.quantityInput || '';

        if (current.length <= 1) {
            this.setState({ quantityInput: '' });
            return;
        }

        current = current.slice(0, -1);

        this.setState({ quantityInput: current });
    }

    clearQuantity = () => {
        this.setState({ quantityInput: '' });
    }

    resetQuantity = () => {
        this.setState({ quantityInput: '' });
    }

    getParsedQuantity = () => {
        const rawValue = this.state.quantityInput;

        if (!rawValue || rawValue.trim() === '') {
            return 1;
        }

        const parsed = parseFloat(rawValue);

        if (isNaN(parsed) || parsed <= 0) {
            return 1;
        }

        return parsed;
    }

    updateTerminalId(terminalId, callback) {
        localStorage['terminalId'] = terminalId;
        this.props.changeTerminalId(terminalId);

        Logger.log('updateTerminalId gelen', terminalId);

        if (callback) {
            callback(terminalId);
        }
    }

    ensureTerminalId = (callback) => {
        if (this.props.terminalId) {
            callback(this.props.terminalId);
            return;
        }

        if (localStorage['terminalId']) {
            const terminalId = localStorage['terminalId'];
            this.props.changeTerminalId(terminalId);
            callback(terminalId);
            return;
        }

        Queries.registerTerminal((terminalId) => {
            this.updateTerminalId(terminalId, callback);
        });
    }

    getHeader(ticket = { entities: [] }) {
        var title = ticket.id === undefined ? 'POS24' :
            ticket.id > 0 ? 'Sipariş' : 'Yeni sipariş';
        var entityList = ticket != null && ticket.entities.length > 0 ? ticket.entities.map(x => x.name).join() : undefined;
        return title + (entityList ? ` (${entityList})` : '');
    }

    render() {

        if (!this.isLoginReady()) {
            return null;
        }

        const { ticket } = this.props;
        const hasTicket = !!ticket;

        const hasTable =
            ticket &&
            ticket.entities &&
            ticket.entities.some(x => x.type === 'Masalar');

        const commands = [
            {
                command: this.cleanTicket,
                caption: 'Temizle',
                color: 'White',
                disabled: false
            },
            {
                command: this.selectTable,
                caption: 'Masalar',
                color: 'White',
                disabled: hasTable === true
            }
        ];

        const ticketActions = this.loadTicketActions();

        ticketActions
            .filter(x => this.isTicketActionVisible(x))
            .forEach(action => {
                const requiresTable = action.requiresTable === true;
                const adminOnly = action.adminOnly === true;

                commands.push({
                    command: () => this.executeTicketAction(action),
                    caption: action.caption,
                    color: action.color || 'White',
                    foreground: action.foreground || 'Black',
                    disabled:
                        !hasTicket ||
                        (requiresTable && !hasTable) ||
                        (adminOnly && this.state.isAdmin !== true)
                });
            });

        commands.push({
            command: this.closeTicket,
            caption: 'Kapat',
            color: 'Orange',
            foreground: 'White',
            disabled: false
        });

        return (
            <div className='mainDiv'>
                <Header header={this.getHeader(ticket)} onLogout={this.handleLogout} />

                <div className={hasTicket ? 'mainBody hasTicket' : 'mainBody noTicket'}>
                    {hasTicket &&
                        <Menu
                            ticket={ticket}
                            disabled={this.state.isAddingOrder}
                            onMenuItemClick={this.onMenuItemClick}
                            toggleQuantityPad={this.toggleQuantityPad} />
                    }

                    {!hasTicket &&
                        <div className="newTicketPanel">
                            <RaisedButton
                                label="Yeni Adisyon"
                                primary={true}
                                onClick={this.createNewTicket}
                            />
                        </div>
                    }

                    <Orders
                        ticket={ticket}
                        isAdmin={this.state.isAdmin}
                        startBusy={this.startBusy}
                        stopBusy={this.stopBusy}
                    />

                    <MyTickets ticket={ticket} onClick={this.onTicketClick} />
                </div>

                <TicketTags ticket={ticket} />

                <Commands commands={commands} />

                <TicketTotal onTotalLabelClick={this.handleMobileTotalLogout} />

                <Snackbar
                    open={this.props.isMessageOpen}
                    message={this.props.message}
                    autoHideDuration={4000}
                    onRequestClose={this.closeMessage}
                />

                {this.state.isQuantityPadOpen &&
                    <QuantityPad
                        value={this.state.quantityInput}
                        onAppend={this.appendQuantityValue}
                        onBackspace={this.backspaceQuantity}
                        onClear={this.clearQuantity}
                        onClose={this.closeQuantityPad}
                    />
                }

                {this.state.isBusy &&
                    <div className="busyOverlay">
                        <div className="busyBox">
                            <div className="busySpinner"></div>
                            <div className="busyText">{this.state.busyMessage}</div>
                        </div>
                    </div>
                }
            </div>
        );
    }

    onTicketClick = (ticketId) => {
        Logger.log('Ticket Open', ticketId);

        this.startBusy('Sipariş yükleniyor...');

        this.ensureTerminalId((terminalId) => {
            Queries.loadTerminalTicket(terminalId, ticketId, (ticket) => {
                try {
                    this.props.setTicket(ticket);
                } finally {
                    this.stopBusy();
                }
            });
        });
    }

    createNewTicket = () => {
        this.startBusy('Yeni adisyon açılıyor...');

        this.ensureTerminalId((terminalId) => {
            Queries.createTerminalTicket(terminalId, (ticket) => {
                try {
                    this.props.setTicket(ticket);
                    this.closeMessage();
                } finally {
                    this.stopBusy();
                }
            });
        });
    }

    onMenuItemClick = (productId, orderTags = '', automationCommand = '') => {
        if (this.isAddingOrderLocked || this.state.isAddingOrder) {
            this.props.updateMessage('Ürün ekleme işlemi devam ediyor. Lütfen bekleyin.');
            return;
        }

        const normalizedAutomationCommand =
            automationCommand
                ? automationCommand.trim()
                : '';

        const quantity = this.getParsedQuantity();
        this.isAddingOrderLocked = true;
        this.setState({ isAddingOrder: true });

        this.startBusy('Ürün ekleniyor...');

        if (!this.props.ticket) {
            Queries.createTerminalTicket(this.props.terminalId, (ticket) => {
                this.props.setTicket(ticket);

                Queries.addOrderToTerminalTicket(
                    this.props.terminalId,
                    productId,
                    quantity,
                    orderTags,
                    (updatedTicket) => {
                        if (!this.validateTicketAfterTerminalOperation(ticket, updatedTicket, 'addOrderToTerminalTicket')) {
                            this.finishAddOrder();
                            return;
                        }

                        this.applyAutomationAfterAdd(
                            ticket,
                            updatedTicket,
                            productId,
                            normalizedAutomationCommand,
                            () => {
                                this.closeMessage();
                                this.resetQuantity();
                                this.closeQuantityPad();
                                this.finishAddOrder();
                            }
                        );
                    }
                );
            });

            return;
        }

        const beforeTicket = this.props.ticket;

        Queries.addOrderToTerminalTicket(
            this.props.terminalId,
            productId,
            quantity,
            orderTags,
            (ticket) => {
                if (!this.validateTicketAfterTerminalOperation(beforeTicket, ticket, 'addOrderToTerminalTicket')) {
                    this.finishAddOrder();
                    return;
                }

                this.applyAutomationAfterAdd(
                    beforeTicket,
                    ticket,
                    productId,
                    normalizedAutomationCommand,
                    () => {
                        this.closeMessage();
                        this.resetQuantity();
                        this.closeQuantityPad();
                        this.finishAddOrder();
                    }
                );
            }
        );
    }

    applyAutomationAfterAdd = (beforeTicket, updatedTicket, productId, automationCommand, done) => {
        const command = automationCommand ? automationCommand.trim() : '';

        if (!command) {
            this.props.setTicket(updatedTicket);
            if (done) done();
            return;
        }

        const beforeOrderUids = beforeTicket && beforeTicket.orders
            ? beforeTicket.orders.map(x => x.uid)
            : [];

        const addedOrder = updatedTicket && updatedTicket.orders
            ? updatedTicket.orders.find(x =>
                String(x.productId) === String(productId) &&
                beforeOrderUids.indexOf(x.uid) === -1
            )
            : null;

        if (!addedOrder) {
            this.props.setTicket(updatedTicket);
            if (done) done();
            return;
        }

        Queries.executeAutomationCommandForTerminalTicket(
            this.props.terminalId,
            addedOrder.uid,
            command,
            'Müşteri',
            (ticketAfterAutomation) => {
                const resultTicket = ticketAfterAutomation || updatedTicket;

                if (!this.validateTicketAfterTerminalOperation(updatedTicket, resultTicket, 'executeAutomationCommandForTerminalTicket')) {
                    if (done) done();
                    return;
                }

                this.props.setTicket(resultTicket);
                if (done) done();
            }
        );
    }

    finishAddOrder = () => {
        this.isAddingOrderLocked = false;
        this.setState({ isAddingOrder: false });
        this.stopBusy();
    }

    validateTicketAfterTerminalOperation(expectedTicket, resultTicket, actionName) {
        if (!resultTicket) {
            console.error('[TICKET SAFETY]', actionName, 'empty result ticket', {
                terminalId: this.props.terminalId,
                expected: this.getTicketDebugInfo(expectedTicket)
            });
            this.props.updateMessage('Ürün eklenemedi. Lütfen adisyonu kontrol edip tekrar deneyin.');
            return false;
        }

        const expectedIdentity = this.getTicketIdentity(expectedTicket);
        const resultIdentity = this.getTicketIdentity(resultTicket);

        if (!expectedIdentity || !resultIdentity || expectedIdentity === resultIdentity) {
            return true;
        }

        this.props.updateMessage('Adisyon değişmiş görünüyor. Lütfen masayı kontrol edip tekrar deneyin.');
        console.error('[TICKET SAFETY]', actionName, 'ticket mismatch blocked', {
            terminalId: this.props.terminalId,
            expected: this.getTicketDebugInfo(expectedTicket),
            result: this.getTicketDebugInfo(resultTicket)
        });

        return false;
    }

    getTicketIdentity(ticket) {
        if (!ticket) {
            return '';
        }

        if (ticket.uid) {
            return String(ticket.uid);
        }

        if (ticket.id !== undefined && ticket.id !== null) {
            return String(ticket.id);
        }

        return '';
    }

    getTicketDebugInfo(ticket) {
        if (!ticket) {
            return {};
        }

        return {
            id: ticket.id,
            uid: ticket.uid,
            number: ticket.number,
            entities: ticket.entities ? ticket.entities.map(x => x.name).join(',') : '',
            orderCount: ticket.orders ? ticket.orders.length : 0
        };
    }

    cleanTicket = () => {
        this.ensureTerminalId((terminalId) => {
            Queries.clearTerminalTicketOrders(terminalId, (ticket) => {
                this.props.setTicket(ticket);
            });
        });
    }

    selectTable = () => {
        if (!this.props.ticket) {
            this.props.updateMessage('Önce siparişi seçiniz !');
            return;
        }

        if (this.hasSelectedTable(this.props.ticket)) {
            this.props.updateMessage('Bu sipariş için masa zaten seçilmiş.');
            return;
        }

        this.context.router.push({
            pathname: '/entities',
            query: {
                terminalId: this.props.terminalId,
                screenName: appconfig().entityScreenName
            }
        });
    }

    closeTicket = () => {
        const ticket = this.props.ticket;

        if (!ticket) {
            this.props.setTicket(undefined);
            return;
        }

        const hasOrders = ticket.orders && ticket.orders.length > 0;

        if (!hasOrders) {
            this.props.setTicket(undefined);
            return;
        }

        const hasTable = this.hasSelectedTable(ticket);

        if (!hasTable) {
            this.context.router.push({
                pathname: '/entities',
                query: {
                    terminalId: this.props.terminalId,
                    screenName: appconfig().entityScreenName,
                    afterSelect: 'closeTicket'
                }
            });
            return;
        }

        this.startBusy('Sipariş kapatılıyor...');

        Queries.closeTerminalTicket(this.props.terminalId, (errorMessage) => {
            try {
                Queries.postRefresh();
                Queries.broadcastMessage('{"eventName":"TASK_PRINTED","terminal":"Server","userName":"Administrator","productType":"Food"}');

                this.setState({ errorMessage: errorMessage });

                if (ticket.id == 0) {
                    this.props.updateMessage('Sipariş başarılı bir şekilde gönderildi!');
                } else {
                    this.props.updateMessage('Sipariş işlemi tamamlandı.');
                }

                this.props.setTicket(undefined);

                if (this.props.ticketsNeedsRefresh) {
                    this.props.ticketsNeedsRefresh();
                }
            } finally {
                this.stopBusy();
            }
        });
    }

    hasSelectedTable = (ticket) => {
        return !!(
            ticket &&
            ticket.entities &&
            ticket.entities.some(x => x.type === 'Masalar')
        );
    }

    loadInposTsmVisibility = () => {
        var apiBaseUrl = localStorage['pos24_api_base_url'];

        if (!apiBaseUrl || apiBaseUrl.trim() === '') {
            localStorage['show_inpos_tsm_button'] = 'false';
            this.setState({ showInposTsmButton: false });
            return;
        }

        getOnlyTsmEnabled(
            (isEnabled) => {
                const visible = isEnabled === true;

                localStorage['show_inpos_tsm_button'] = visible ? 'true' : 'false';

                this.setState({
                    showInposTsmButton: visible
                });
            },
            () => {
                localStorage['show_inpos_tsm_button'] = 'false';
                this.setState({ showInposTsmButton: false });
            }
        );
    }

    hesapYaz = () => {
        if (this.props.ticket == undefined) {
            this.props.updateMessage('Önce siparişi seçiniz');
            return;
        }

        if (
            this.props.ticket.orders == undefined ||
            this.props.ticket.orders.length === 0
        ) {
            this.props.updateMessage('Siparişe ürün eklemeniz gerekmektedir.');
            return;
        }

        const orderUid = this.props.ticket.uid;

        this.startBusy('Hesap yazdırılıyor...');

        Queries.executeHesapYazForTerminalTicket(
            this.props.terminalId,
            orderUid,
            (ticket) => {
                try {
                    Queries.postRefresh();

                    this.props.updateMessage('Siparişiniz yazdırıldı.');

                    if (ticket) {
                        this.props.setTicket(undefined);
                    }
                } finally {
                    this.stopBusy();
                }
            }
        );
    }

    inposTSM = () => {
        if (this.props.ticket == undefined) {
            this.props.updateMessage('Önce siparişi seçiniz');
            return;
        }

        if (this.props.ticket.orders == undefined || this.props.ticket.orders.length === 0) {
            this.props.updateMessage('Siparişe ürün eklemeniz gerekmektedir.');
            return;
        }

        if (this.props.ticket.id == 0) {
            this.props.updateMessage('Önce siparişi kaydediniz.');
            return;
        }

        const orderUid = this.props.ticket.uid;

        this.startBusy('Inpos TSM işlemi yapılıyor...');

        Queries.executeInposTSMForTerminalTicket(
            this.props.terminalId,
            orderUid,
            (ticket) => {
                try {
                    Queries.postRefresh();

                    const payload = mapTicketForOkc(this.props.ticket);
                    this.sendTicketToOkc(payload);

                    this.props.updateMessage('İşlem başarıyla gönderildi.');
                    this.props.setTicket(undefined);

                    if (this.props.ticketsNeedsRefresh) {
                        this.props.ticketsNeedsRefresh();
                    }
                } finally {
                    this.stopBusy();
                }
            }
        );
    }

    closeMessage = () => {
        if (this.props.isMessageOpen)
            this.props.closeMessage();
    };

    hasSavedConnection = () => {
        return !!(
            localStorage['graphql_base_url'] &&
            localStorage['graphql_base_url'].trim() !== ''
        );
    }

    hasSavedUser = () => {
        return !!(
            localStorage['login_user_name'] &&
            localStorage['login_user_name'].trim() !== ''
        );
    }

    isLoginReady = () => {
        return this.hasSavedConnection() &&
            this.hasSavedUser() &&
            !!localStorage['refresh_token'];
    }

    redirectToLoginIfNeeded = () => {
        if (!this.isLoginReady()) {
            if (window.location.hash !== '#/login') {
                window.location.hash = '#/login';
            }
            return true;
        }

        return false;
    }

    sendTicketToOkc = (ticket) => {
        addOrderToOkc(
            ticket,
            (response) => {
                if (response && response.result) {
                    this.props.updateMessage(response.message || 'Sipariş OKC API ye gönderildi.');
                } else {
                    this.props.updateMessage(response.message || 'OKC API başarısız cevap verdi.');
                }
            },
            (errorResponse) => {
                console.error('OKC AddOrder fail:', errorResponse);
                this.props.updateMessage(errorResponse.message || 'OKC API bağlantı hatası.');
            }
        );
    }

    loadCurrentUser = () => {
        Queries.getCurrentUser((user) => {
            var isAdmin =
                user &&
                user.userRole &&
                user.userRole.isAdmin === true;

            localStorage['current_user_is_admin'] = isAdmin ? 'true' : 'false';

            this.setState({
                currentUser: user,
                isAdmin: isAdmin,
                isUserLoaded: true
            });
        });
    }

    handleLogout = () => {
        try {
            localStorage.removeItem('terminalId');
            localStorage.removeItem('current_user_is_admin');
            localStorage.removeItem('show_inpos_tsm_button');

            window.location.hash = '#/login';
        } catch (e) {
            console.error('Logout error:', e);
            window.location.hash = '#/login';
        }
    };

    handleMobileTotalLogout = () => {
        const isMobile = typeof window !== 'undefined' && window.innerWidth <= 480;

        if (!isMobile) {
            return;
        }

        if (this.props.ticket) {
            this.props.updateMessage('Açık adisyon varken çıkış yapılamaz.');
            return;
        }

        if (window.confirm('Çıkış yapılacaktır. Devam etmek istiyor musunuz?')) {
            this.handleLogout();
        }
    }

    loadTicketActions = () => {
        try {
            const raw = localStorage['pos24_ticket_actions'];
            return raw ? JSON.parse(raw) : [];
        } catch (e) {
            return [];
        }
    }

    isTicketActionVisible = (action) => {
        return !!action;
    }

    executeTicketAction = (action) => {
        const ticket = this.props.ticket;

        if (!ticket) {
            this.props.updateMessage('Önce siparişi seçiniz.');
            return;
        }

        if (!ticket.orders || ticket.orders.length === 0) {
            this.props.updateMessage('Siparişe ürün eklemeniz gerekmektedir.');
            return;
        }

        const commandName = (action.commandName || '').trim();
        const commandValue = (action.commandValue || '').trim();

        if (!commandName) {
            this.props.updateMessage('Automation command boş olamaz.');
            return;
        }

        this.startBusy(commandName + ' işlemi yapılıyor...');

        Queries.executeAutomationCommandForTerminalTicket(
            this.props.terminalId,
            ticket.uid,
            commandName,
            commandValue,
            (updatedTicket) => {
                try {
                    Queries.postRefresh();

                    this.props.updateMessage(action.caption + ' işlemi tamamlandı.');

                    if (updatedTicket) {
                        this.props.setTicket(updatedTicket);
                    }
                } finally {
                    this.stopBusy();
                }
            }
        );
    }
}

App.contextTypes = {
    router: React.PropTypes.object
};

App.defaultProps = {
    message: '',
    isMessageOpen: false,
    menu: { categories: [] },
    menuItems: []
};

App.PropTypes = {
    terminalId: PropTypes.number,
    message: PropTypes.object,
    isMessageOpen: PropTypes.boolean,
    ticket: PropTypes.object
};

const mapStateToProps = state => ({
    terminalId: state.app.get('terminalId'),
    message: state.app.getIn(['message', 'text']),
    isMessageOpen: state.app.getIn(['message', 'isOpen']),
    ticket: state.app.get('ticket')
});

const mapDispatchToProps = ({
    changeTerminalId: Actions.chageTerminalId,
    updateMessage: Actions.updateMessage,
    closeMessage: Actions.closeMessage,
    setTicket: Actions.setTicket,
    ticketsNeedsRefresh: Actions.ticketsNeedsRefresh
});

function mapTicketForOkc(ticket) {
    return {
        id: ticket.id,
        uid: ticket.uid,
        type: ticket.type,
        number: ticket.number,
        date: ticket.date,
        totalAmount: ticket.totalAmount,
        remainingAmount: ticket.remainingAmount,
        tableName: buildTableName(ticket),
        ticketNote: ticket.ticketNote || '',
        entities: ticket.entities || [],
        states: ticket.states || [],
        tags: ticket.tags || [],
        orders: (ticket.orders || []).map(x => ({
            id: x.id,
            uid: x.uid,
            productId: x.productId,
            name: x.name,
            quantity: x.quantity,
            portion: x.portion,
            price: x.price,
            priceTag: x.priceTag,
            calculatePrice: x.calculatePrice,
            increaseInventory: x.increaseInventory,
            decreaseInventory: x.decreaseInventory,
            locked: x.locked,
            taxes: x.taxes,
            tags: x.tags || [],
            states: x.states || []
        }))
    };
}

function buildTableName(ticket) {
    if (!ticket) {
        return 'Yeni Sipariş ' + Math.floor(1000 + Math.random() * 9000);
    }

    const entities = ticket.entities || [];
    const tableEntity = entities.find(x => x && x.name);
    const tableName = tableEntity && tableEntity.name ? String(tableEntity.name).trim() : '';
    const ticketNumber = ticket.number ? String(ticket.number).trim() : '';

    if (tableName && ticketNumber) {
        return 'Masa ' + tableName + ' ' + ticketNumber;
    }

    if (ticketNumber) {
        return ticketNumber;
    }

    if (tableName) {
        return 'Masa ' + tableName;
    }

    return 'Yeni Sipariş ' + Math.floor(1000 + Math.random() * 9000);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./app/components/App.jsx